export default "assets/logo-icon-4143b8b9.svg";